import React from 'react';
import productImage from '../assets/SIMVR_AVATAR_IA.png'; // Adjust the path as necessary
import CallToAction from './CallToAction';
import AvatarAI from './AvatarIA';
function Header() {
    return (
      <header className="App-header">
        <div className="container py-5">
            <h1 style={{ color: '#3AF87F', fontWeight: 'bold', fontSize:'5vh'}}>Asistente Virtual con IA</h1>
            <h2 className="mt-3">Un asistente virtual 24/7, con apariencia humana y manejo de idiomas para brindar un mejor soporte en tu empresa.</h2>

            {/*<img src={productImage} alt="SIMVR AVATAR IA Product Image" />*/}
            <AvatarAI/>
            <h3>Impulsa el rendimiento de tu equipo con un asistente IA incansable que responde al instante y transmite una imagen confiable y profesional en todo momento, con conocimiento base de tu empresa</h3>
            <CallToAction text="¡Pruébalo AHORA!" message="Quiero agendar una reunión para probar el asistente virtual." actionId="demo" color="#46D078" />
        </div>
      </header>
    );
}
  
export default Header;